import React, { useState } from "react"
import { Input } from "reactstrap"
import { fetchNodeData } from "utils/common-fetchData"

const getTodayDate = () => {
  const today = new Date()
  let month = String(today.getMonth() + 1)
  let day = String(today.getDate())
  const year = today.getFullYear()

  // Add leading zeros if needed
  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return `${year}-${month}-${day}`
}

export const LinkedinAccountsColumns = (updateType, deleteContractType) => [
  {
    Header: "ID",
    accessor: "id",
    className: "col-md-1 text-center",
  },
  {
    Header: "Account Name",
    accessor: "username",
    className: "col-md-4",
  },
  {
    Header: "Assignees",
    accessor: "assignee",
    className: "col-md-5",
    Cell: cellProps => {
      const assignees = cellProps?.row?.original?.assignee

      return (
        <div>
          {Array.isArray(assignees) && assignees.length > 0
            ? assignees.map(a => a.username).join(", ")
            : "-"}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "action",
    className: " text-center",
    Cell: cellProps => {
      return (
        <div>
          <a
            onClick={() => {
              updateType(
                cellProps.row.original.id,
                cellProps.row.original.username,
                cellProps.row.original.assignee
              )
            }}
            className="btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </a>
          <a
            onClick={() => {
              deleteContractType(cellProps.row.original.id)
            }}
            className="btn btn-sm  btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </a>
        </div>
      )
    },
  },
]

export const LinkedinReportColumns = handleSave => [
  {
    Header: "LinkedIn Account",
    accessor: "username",
    className: "col-md-4",
    Cell: ({ row }) => {
      const obj = row.original

      return (
        <div className="d-flex align-items-center">
          <span>{obj?.username}</span>
        </div>
      )
    },
  },
  {
    Header: "Followers (Current)",
    className: "col-md-5 text-center",
    Cell: cellProps => {
      const [cc, setCc] = useState(null)
      const [date, setDate] = useState("")

      const fetchCounts = async date => {
        try {
          const res = await fetchNodeData(
            false,
            `linkedin/fetchCounts/${cellProps?.row?.original?.account}/${date}`
          )

          const count = res?.data?.count ?? null

          setCc(count) // will be number or null
        } catch (err) {
          console.error(err)
          setCc(null)
        }
      }

      return (
        <div key={cellProps.row.original.id} className="d-flex justify-content-center gap-2">
          <input
            type="date"
            required
            value={date}
            // disabled={cellProps.row.original.date == moment().format}
            className="form-control"
            style={{ maxWidth: "170px" }}
            onChange={e => {
              setDate(e.target.value)
              fetchCounts(e.target.value)
            }}
            max={getTodayDate()}
          />
          <Input
            type="number"
            className="form-control"
            placeholder="Enter count"
            style={{ maxWidth: "170px" }}
            onChange={e => setCc(e.target.value)}
            value={cc ?? ""}
          />
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              console.log("dhavyhdcb: ", cellProps.row.original)
              handleSave(cellProps.row.original, cc, date)
            }}
          >
            <i className="fa fa-check pr-2"></i>
          </button>
        </div>
      )
    },
  },
]
